// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Universe L-Space - Main Export
 * 
 * L-Space (Library Space) - where all libraries are connected.
 * A dimension of pure knowledge accessible through the Unseen University.
 * Ook!
 */

import { starSystems, spaceStations } from './StarSystemsConfig';
import { warpGates, warpGatePositions } from './WarpGatesConfig';
import { LSpaceAliensPlanets } from './AliensConfig';

// Star system positions on the 3D map
const starPositions = {
  800: { x: 50, y: 50, z: 0 },   // THE GREAT LIBRARY (center)
  801: { x: 35, y: 40, z: 8 },   // ALEXANDRIA ETERNAL
  802: { x: 65, y: 45, z: -10 }, // BABEL TOWER
  803: { x: 25, y: 30, z: -15 }, // THE FORBIDDEN SECTION
  804: { x: 70, y: 60, z: 12 },  // DIGITAL ARCHIVES
  805: { x: 45, y: 70, z: 15 },  // THE UNWRITTEN LIBRARY
  806: { x: 80, y: 75, z: 20 },  // AKASHIC RECORDS
  807: { x: 30, y: 65, z: -8 },  // THE BURNING LIBRARY
  808: { x: 55, y: 35, z: 5 },   // MEMORY PALACE
  809: { x: 85, y: 50, z: -18 }, // THE INFINITE BOOKSHELF
};

// Space station positions on the 3D map
const stationPositions = {
  900: { x: 48, y: 52, z: 3 },   // LIBRARIAN'S OUTPOST
  901: { x: 60, y: 55, z: -5 },  // READER'S REST
  902: { x: 40, y: 48, z: 10 },  // BOOKBINDER'S WORKSHOP
};

export const universeLSpace = {
  id: 'lspace',
  name: 'L-Space',
  description: 'The infinite library dimension where all knowledge exists',
  starSystems,
  spaceStations,
  starPositions,
  stationPositions,
  warpGates,
  warpGatePositions,
  aliens: LSpaceAliensPlanets,
};

export default universeLSpace;
